export default __webpack_public_path__ + "static/media/new-pitch.a0453212.svg";